module.exports = __webpack_public_path__ + "img/header_mypage.f0141967.svg";